module.exports = __webpack_public_path__ + "img/q1.c3489a62.jpg";